import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { PartialId } from '@attain-apps/string-builder'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as common from '../../../../common'

export const DOC = gql`
  mutation SaveAgentConfiguration(
    $tenantId: ID!
    $zoneId: ID!
    $configuration: AgentConfigurationInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        saveAgentConfiguration(configuration: $configuration) {
          agentId
          conversationId
          context {
            dmsResources
            instructions
            knowledgeBaseFiles {
              knowledgeBaseId
              s3Uri
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.validate(
  graphql.transformers.OUT.select<
    graphql.schema.SaveAgentConfigurationMutation,
    ents.core.agent.Configuration | undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'saveAgentConfiguration',
        graphql.transformers.OUT.object({
          agentId: graphql.transformers.OUT.nonNull(
            common.gql.enums.agentId.TRANSFORMER,
          ),
          context: {
            usingFullInput: graphql.transformers.OUT.default(
              graphql.transformers.OUT.object({
                dmsResources: {
                  usingFullInput: graphql.transformers.OUT.nonNull(
                    graphql.transformers.OUT.select(
                      'context',
                      graphql.transformers.OUT.select(
                        'dmsResources',
                        graphql.transformers.OUT.json(),
                      ),
                    ),
                  ),
                },
                instructions: {
                  usingFullInput: graphql.transformers.OUT.select(
                    'context',
                    graphql.transformers.OUT.select(
                      'instructions',
                      transformers.PASS_THROUGH,
                    ),
                  ),
                },
                knowledgeBaseFiles: {
                  usingFullInput: graphql.transformers.OUT.select(
                    'context',
                    graphql.transformers.OUT.select(
                      'knowledgeBaseFiles',
                      graphql.transformers.OUT.list(
                        graphql.transformers.OUT.object({
                          knowledgeBaseId: graphql.transformers.OUT.nonNull(
                            transformers.PASS_THROUGH,
                          ),
                          s3Uri: graphql.transformers.OUT.nonNull(
                            transformers.PASS_THROUGH,
                          ),
                        }),
                        { onNullish: 'remove' },
                      ),
                    ),
                  ),
                },
              }),
              // This is database default
              {},
            ),
          },
          conversationId: {
            usingFullInput: graphql.transformers.OUT.select(
              'conversationId',
              graphql.transformers.OUT.validate(
                transformers.PASS_THROUGH,
                TypeAsserter.Factory.from(
                  TypeChecker.Factory.optional(PartialId.isPartialId),
                ),
              ),
            ),
          },
        }),
      ),
    ),
  ),
  TypeAsserter.assertIsNotNullish,
  { warnOnly: true },
)

export const executor = graphql.createExecutor<
  graphql.schema.SaveAgentConfigurationMutation,
  ents.core.agent.Configuration | undefined,
  graphql.schema.SaveAgentConfigurationMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
